<template>

  <v-container fluid class="provider-order-receiver-selector" v-if="selections">
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="6" lg="4" class="pa-6" v-for="receiver in selections" :key="`item-${receiver.id}`">
        <v-row class="selection-container" :class="{ selected: selected && selected.id === receiver.id }" @click="setSelected(receiver)">
          <v-col cols="3" class="d-flex align-center justify-center">
            <v-icon large color="success" v-if="selected && selected.id === receiver.id">mdi-check-circle-outline</v-icon>
            <v-icon large class="selection-icon" v-else>mdi-circle-outline</v-icon>
          </v-col>
          <v-col cols="9" align="left">
            <div class="mb-2 receiver-name">{{ receiver.name }}</div>
            <div>
              <div>{{ formatAddress(receiver).street_1 }}</div>
              <span v-if="formatAddress(receiver).street_2">,</span> {{ formatAddress(receiver).street_2 }}
              <template v-if="formatAddress(receiver).area">{{ formatAddress(receiver).area }}</template>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="4" key="item-na" class="d-flex align-center justify-center">
        <div class="not-listed-container" :class="{ selected: selected && selected === 'na' }" @click="setSelected('na')">
          <div class="mb-4">
            <v-icon large color="success" v-if="selected && selected === 'na'">mdi-check-circle-outline</v-icon>
            <v-icon large class="selection-icon" v-else>mdi-circle-outline</v-icon>
          </div>
          The location is not listed
        </div>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  name: 'ProviderOrderReceiverSelector',

  props: {
    value: {
      type: [Object, String, null],
      default: null
    },
    selections: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      selected: this.value
    }
  },

  watch: {
    selected (updated) {
      this.$emit('input', updated)
    }
  },

  methods: {
    formatAddress (data = {}) {
      return this.$root.utils.getAddressTextFromData(data, { multi_lines: true })
    },

    setSelected (receiver) {
      this.selected = receiver
    }
  }
}
</script>

<style scoped>
  .provider-order-receiver-selector {
    border: 1px solid #f8a824;
    border-radius: 6px;
    padding: 24px 12px;
  }

  .provider-order-receiver-selector .selection-container {
    color: #727272;
    border: 1px solid #7c7c7c;
    border-radius: 4px;
    padding: 12px;
  }

  .provider-order-receiver-selector .selection-container:hover {
    cursor: pointer;
    color: #c9c9c9;
    border: 1px solid #c9c9c9;
  }

  .provider-order-receiver-selector .selection-container.selected {
    color: #c9c9c9;
    border: 2px solid #c9c9c9;
  }

  .provider-order-receiver-selector .not-listed-container {
    color: #727272;
    padding: 12px;
  }

  .provider-order-receiver-selector .not-listed-container:hover {
    cursor: pointer;
    color: #c9c9c9;
  }

  .provider-order-receiver-selector .not-listed-container.selected {
    color: #c9c9c9;
  }

  .provider-order-receiver-selector .selection-icon {
    color: #7c7c7c;
  }

  .provider-order-receiver-selector .selection-icon.selected {
    color: #c9c9c9;
  }

  .provider-order-receiver-selector .receiver-name {
   font-size: 19px;
  }
</style>
